import React from 'react';

import { StyleSheet } from 'react-native';

import { Logo as BrandLogo } from 'components/logo';
import { Box } from 'components/ui';

import { CartErrorHeading, Heading } from './styled';

interface ICartHeading {
  modalHeading?: string;
}

const styles = StyleSheet.create({
  logoContainer: {
    marginTop: 56,
    height: 55,
  },
});

const HeadingContainer = ({ modalHeading }: ICartHeading = {}) => (
  <Heading>
    <Box style={styles.logoContainer}>
      <BrandLogo />
    </Box>
    <CartErrorHeading>{modalHeading}</CartErrorHeading>
  </Heading>
);

export default HeadingContainer;
